export default "__VITE_ASSET__CXkQr1Fj__"